
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.76 0H17.24a4.927 4.927 0 00-4.922 4.922v41.527c0 1.528.7 2.894 1.794 3.798v4.112c0 .906.735 1.641 1.64 1.641h24.497a1.64 1.64 0 001.64-1.64v-4.113a4.914 4.914 0 001.795-3.798V4.922A4.927 4.927 0 0038.76 0zm-.153 52.719H17.392V51.37h21.215v1.348zm1.794-6.27c0 .905-.735 1.64-1.64 1.64H17.239c-.905 0-1.64-.735-1.64-1.64V17.06H40.4v29.39zm0-32.67H15.598V4.922c0-.905.736-1.64 1.64-1.64h21.523c.904 0 1.64.735 1.64 1.64v8.857z","fill":"#6C7177"}}),_c('path',{attrs:{"d":"M19.78 21.696a1.64 1.64 0 00-1.64 1.64v7.212a1.64 1.64 0 103.281 0v-7.212a1.64 1.64 0 00-1.64-1.64zM19.78 5.67a1.64 1.64 0 00-1.64 1.64v3.276a1.64 1.64 0 103.281 0V7.31a1.64 1.64 0 00-1.64-1.64z","fill":"#6C7177"}})])
          )
        }
      }
    